import React from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import KorivaLanding from './koriva-landing'
import KorivaOnboarding from './koriva-onboarding'
import KorivaLogin from './koriva-login'
import KorivaBrandForm from './koriva-brand-form'
import KorivaDashboard from './koriva-dashboard'
import KorivaWeekly from './koriva-weekly'
import KorivaArchive from './koriva-archive'
import KorivaTracker from './koriva-tracker'
import KorivaAdmin from './koriva-admin'
import KorivaLegal from './koriva-legal'
import KorivaBienvenida from './koriva-bienvenida'
import KorivaRecuperar from './koriva-recuperar'
import KorivaNuevaClave from './koriva-nueva-clave'
import PaymentGuard from './PaymentGuard'

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<KorivaLanding />} />
        <Route path="/onboarding" element={<KorivaOnboarding />} />
        <Route path="/login" element={<KorivaLogin />} />
        <Route path="/brand-form" element={<PaymentGuard><KorivaBrandForm /></PaymentGuard>} />
        <Route path="/dashboard" element={<PaymentGuard><KorivaDashboard /></PaymentGuard>} />
        <Route path="/weekly" element={<PaymentGuard><KorivaWeekly /></PaymentGuard>} />
        <Route path="/archive" element={<PaymentGuard><KorivaArchive /></PaymentGuard>} />
        <Route path="/tracker" element={<PaymentGuard><KorivaTracker /></PaymentGuard>} />
        <Route path="/admin" element={<KorivaAdmin />} />
        <Route path="/bienvenida" element={<KorivaBienvenida />} />
        <Route path="/recuperar" element={<KorivaRecuperar />} />
        <Route path="/nueva-clave" element={<KorivaNuevaClave />} />
        <Route path="/terminos" element={<KorivaLegal doc="terminos" />} />
        <Route path="/privacidad" element={<KorivaLegal doc="privacidad" />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
